import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { ILabsState } from '../../procedures/labs/store/labs.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { getLabsSelector } from '../../procedures/labs/selectors/labs.selector'
import { compareObjectsIfEqual, filterOutObjectKeys } from '../../../utilities/object.util'
import { initialLabsState } from '../../procedures/labs/store/labs.reducer'

export function* addLabsItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const labsState: ILabsState = yield select(getLabsSelector)
  const { pta, key, time, date, assessedBy, comments, isEkgImport } = labsState
  const fieldsToFilter = ['key']
  const currentState = filterOutObjectKeys(labsState, fieldsToFilter)
  const initalState = filterOutObjectKeys(initialLabsState, fieldsToFilter)
  const addToTimeline = !compareObjectsIfEqual(currentState, initalState)
  if (addToTimeline) {
    const clientCorrelationId = `patient.labsStateList${key}`

    const assessedByLabel = assessedBy?.name || ''
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }

    const filterProps = ['key', 'date', 'time', 'comments', 'type']
    const labValues: string[] = []
    Object.keys(labsState).forEach((prop) => {
      if (labsState[prop as keyof typeof labsState] && typeof labsState[prop as keyof typeof labsState] === 'string') {
        const value = labsState[prop as keyof typeof labsState]
        if (!filterProps.includes(prop) && value) labValues.push(`${prop}:${value}`)
      }
    })
    const item: IItem = {
      key: key,
      grid: true,
      clientCorrelationId,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Labs',
      eventSubHeader: `By ${assessedByLabel}, Lab values: ${labValues.join(', ')}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_LABS_PROCEDURE_ITEM,
      defaultHref: TabConstants.LABS_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addLabsItemSaga() {
  yield takeLatest([TimelineConstants.ADD_LABS_ITEM], addLabsItem)
}
